<template>
	<marquee-text
		v-if="loaded"
		:duration="totalDuration"
		:repeat="10"
		:reverse="reverse"
	>
		<div class="team-marquee__marquee">
			<div
				class="team-marquee__marquee-person"
				v-for="teammember in teammembers"
				:key="teammember.ID"
			>
				<picture class="image team-marquee__marquee-person-cover">
					<img
						class="team-marquee__marquee-person-image"
						:src="teammember.image"
					/>
				</picture>
				<div class="team-marquee__marquee-person-text">
					{{ teammember.name }}
				</div>
				<div class="team-marquee__marquee-person-textarea">
					{{ teammember.role }}
				</div>
			</div>
		</div>
	</marquee-text>
</template>

<script>
import MarqueeText from "vue-marquee-text-component";

export default {
	name: "TeamMarquee",
	data() {
		return {
			loaded: false,
			teammembers: [],
			reverse: false,
		};
	},
	props: ["items", "direction", "speed"],
	computed: {
		totalDuration() {
			return 5 * this.teammembers.length;
		},
	},
	mounted: function () {
		this.teammembers = JSON.parse(this.items);
		if (this.direction === "reverse") {
			this.reverse = true;
		}
		this.loaded = true;
	},
	components: {
		MarqueeText,
	},
};
</script>
